<script lang="ts">
  import { Router, Route, createHistory } from 'svelte-navigator'
  import Navigation from './lib/Navigation.svelte'
  import Presentations from "./lib/Presentations.svelte";
  import {createHashSource} from "./routing/history";
  import PrivateRoute from "./lib/guard/PrivateRoute.svelte";
  import NewPresentation from "./lib/NewPresentation.svelte";
  import Footer from "./lib/Footer.svelte";
  import AddSuggestion from './lib/AddSuggestion.svelte';
  import ManageSuggestions from './lib/ManageSuggestions.svelte';

  export let url = '';
  const hash = createHistory(createHashSource());
</script>

<div class="app">
  <Router url="{url}" history="{hash}">
    <header>
      <nav>
        <Navigation />
      </nav>
    </header>
    <main class='main-area'>
      <PrivateRoute path="new-presentation"><NewPresentation /></PrivateRoute>
      <PrivateRoute path="list-suggestions"><ManageSuggestions /></PrivateRoute>
      <Route path="add-suggestion"><AddSuggestion /></Route>
      <Route path="/"><Presentations /></Route>
    </main>
  </Router>
  <Footer />
</div>

<style>
  :global(:root) {
    --primary-foreground: #333333;
    --primary-background: #fff;
    --active-foreground: #333;
    --active-background: #1576ee;
  }

  :global(html) {
    height: 100%;
  }

  :global(body) {
    font-family: "Inter", sans-serif;
    font-weight: 400;
    font-size: 16px;
    color: var(--primary-foreground);
    background-color: var(--primary-background);
    height: 100%;
  }

  :global(h1) {
    font-weight: 600;
    font-size: 1.5rem;
  }

  :global(h2) {
    font-weight: 600;
    font-size: 1.2rem;
  }

  :global(#app) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    background-color: #aaa;
    min-height: 100%;
  }

  .app {
    width: 100%;
    background-color: var(--primary-background);
    min-height: 100%;
    position: relative;
    padding-bottom: 3rem;
    box-sizing: border-box;
    overflow: hidden;
  }

  header {
    display: flex;
    flex-direction: row;
    justify-content: stretch;
    flex-wrap: wrap-reverse;
    color: white;
    background-color: var(--bs-dark-rgb) !important;
  }

  aside {
    text-align: right;
    flex-grow: 1;
    flex-shrink: 0;
  }

  nav {
    height: 4rem;
    flex-grow: 1;
    flex-shrink: 0;
  }

  .main-area {
    height: calc(100vh - 7rem);
  }
</style>
